import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { formatDate, returnInputFieldLength } from '../../../utils/commonFunctions';
import { Comments } from '../../commons';
import { OpenItemsCommentType } from '../../../redux/openItems/openItemsTypes';

type AppProps = {
  modal: boolean;
  toggleModal: () => void;
  characterLength?: number;
  data?: any;
  showInputBox?: boolean;
  handlePostComment?: (data?: any) => void;
  commentFetching?: boolean;
  commentsSuccess?: number | null;
  allOpenItemComments: [] | OpenItemsCommentType[];
}

const CommentsModal = ({
  modal,
  toggleModal,
  data,
  showInputBox,
  characterLength,
  handlePostComment,
  allOpenItemComments,
  commentFetching,
  commentsSuccess
}: AppProps) => {
  const [commentText, setCommentText] = useState<string>('');

  useEffect(() => {
    if (!commentsSuccess) {
      setCommentText('')
    }
  }, [commentsSuccess])

  const handleCommentTextChange = (e: any) => {
    setCommentText(e.target.value);
  }

  const handleSubmitComment = (e: any) => {
    e.preventDefault();
    let finalData = {
      commentText: commentText.trim(),
      id: data?.item_id
    }
    handlePostComment?.(finalData)
  }

  const renderAllComments = () => {
    const finalComments = allOpenItemComments?.map((data: OpenItemsCommentType) => {
      return (
        <Comments
          key={data?.comment_id}
          commenterName={data?.commenter_name}
          commentTime={data?.modified_on}
          commentText={data?.comment}
        />
      )
    });

    return finalComments;
  }

  const returnFileFormat = (format: string) => {
    switch (format) {
      case 'image':
        return 'Image';
      case 'word':
        return 'Word';
      case 'pdf':
        return 'PDF';
      case 'excel':
        return 'Excel';
      case 'hard_copy':
        return 'Hard Copy';
      default:
        return 'Image';
    }
  }

  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggleModal}
        className='modal-styles'
      >
        <div className='p-1'>
          <ModalHeader toggle={toggleModal}>
            All Comments
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <h6 className='mb-0'>{data?.item_name}</h6>
                <div className='due-date-text'>{`Due Date: ${formatDate(data?.due_date)} `}<span className={`file-status-${ data?.format }`} style={{fontSize:'12px',padding:'none'}}>{returnFileFormat(data?.format)}</span></div>
              </div>
            </div>
            {showInputBox && <>
              <form>
                <div className="form-group mt-3">
                  <div>
                    <label htmlFor="commentBox"
                      className={commentText ? "active" : ""}
                    >Leave Comment</label>
                    <input
                      type="text"
                      className={`form-control`}
                      name="text"
                      value={commentText}
                      autoFocus
                      onChange={(e) => handleCommentTextChange(e)}
                      maxLength={characterLength}
                      onKeyPress={(e: any) => e.key === 'Enter' ? handleSubmitComment(e) : null}
                    />
                  </div>
                  <div className="input-length text-right mt-1">
                    {returnInputFieldLength(commentText.length, characterLength)}
                  </div>
                </div>
              </form>
              <div className="text-right">
                <span className="pointer" onClick={toggleModal}>Cancel</span>
                <Button
                  color="primary ml-3"
                  onClick={(e: any) => { handleSubmitComment(e) }}
                  disabled={!commentText.length || commentFetching}
                >
                  {commentFetching ? 'Posting...' : 'Post'}
                </Button>
              </div>
            </>
            }
          </ModalBody>
          <ModalFooter>
            {allOpenItemComments?.length > 0 ?
              <div className="w-100 comment-area">
                {renderAllComments()}
              </div> :
              <div className="w-100 text-center due-date-text">No Older Comments!</div>
            }
          </ModalFooter>
        </div>
      </Modal>
    </>
  )
};

export default CommentsModal;